import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import PricingSheet from "./PricingSheet";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur bg-cream/80 border-b border-ink/10">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7 text-[14px] text-ink/80">
          <a href="/#how" className="hover:text-ink underline-link" data-testid="nav-how">How it works</a>
          <a href="/#showcase" className="hover:text-ink underline-link" data-testid="nav-showcase">Showcase</a>
          <a href="/#industries" className="hover:text-ink underline-link" data-testid="nav-industries">Industries</a>
          <Link to="/roi" className="hover:text-ink underline-link" data-testid="nav-roi">ROI calculator</Link>
          <PricingSheet trigger={
            <button className="hover:text-ink underline-link" data-testid="nav-pricing">Pricing</button>
          } />
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/admin/login" className="text-sm font-medium text-ink/70 hover:text-ink" data-testid="nav-signin">
            Sign in
          </Link>
          <Link
            to="/audit"
            className="btn-primary px-4 py-2 rounded-full text-sm font-medium"
            data-testid="nav-cta-audit"
          >
            Free AI audit →
          </Link>
        </div>
        <button
          className="lg:hidden p-2"
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <div
        className={`lg:hidden fixed top-16 right-0 w-full bg-cream border-t border-ink/10 transform transition-transform duration-300 z-40 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          <a href="/#how" className="text-lg" onClick={() => setOpen(false)}>How it works</a>
          <a href="/#showcase" className="text-lg" onClick={() => setOpen(false)}>Showcase</a>
          <a href="/#industries" className="text-lg" onClick={() => setOpen(false)}>Industries</a>
          <Link to="/roi" className="text-lg" onClick={() => setOpen(false)}>ROI calculator</Link>
          <PricingSheet trigger={
            <button className="text-lg text-left" onClick={() => setOpen(false)}>Pricing</button>
          } />
          <Link to="/admin/login" className="text-lg" onClick={() => setOpen(false)}>Sign in</Link>
          <Link
            to="/audit"
            className="btn-primary px-4 py-3 rounded-full text-center mt-2"
            onClick={() => setOpen(false)}
          >
            Free AI audit →
          </Link>
        </div>
      </div>
    </header>
  );
}
